export default __webpack_public_path__ + "static/media/img9.7abdef9d.png";